import Toggle from '@components/Toggle/Toggle';
import { Box, Text } from '@ui-lib';

type OptionalToggleProps = {
  isOptional: boolean;
  onChange: (value: boolean) => void;
};

export const OptionalToggle: React.FC<OptionalToggleProps> = ({ isOptional, onChange }) => {
  return (
    <Box width="full" display="flex" flexDirection="column" gap="xsmall">
      <Box width="full" alignItems="center" justifyContent="spaceBetween" display="flex" flexDirection="row">
        <Text size="medium" weight="demibold">
          Make this field optional
        </Text>
        <Toggle state={isOptional} onChange={onChange}></Toggle>
      </Box>
      <Text tone="secondary" size="small">
        {isOptional
          ? `A card can be created without filling out this field`
          : `A card cannot be created without filling out this field`}
      </Text>
    </Box>
  );
};
